export type AnalyticsEvent =
  | 'pageview'
  | 'cta_click'
  | 'upload'
  | 'start_upscale'
  | 'success'
  | 'fail'
  | 'download'
  | 'pricing_click';

type PlausibleFunction = (
  eventName: string,
  options?: { props?: Record<string, string | number | boolean> }
) => void;

declare global {
  interface Window {
    plausible?: PlausibleFunction;
  }
}

export function track(event: AnalyticsEvent, props?: Record<string, string | number | boolean>) {
  if (typeof window === 'undefined') return;
  try {
    window.plausible?.(event, { props });
  } catch {
    // ignore analytics failures
  }
}

export function trackPageview(path: string) {
  track('pageview', { path });
}
